var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.35 6.5 30 13.25v18.36c0 1.044-.834 1.89-1.862 1.89H11.862c-1.028 0-1.862-.846-1.862-1.89V8.39c0-1.044.834-1.89 1.862-1.89H23.35Zm-.772 1.89H11.862v23.22h16.276V14.033l-5.56-5.643Zm2.5 9.99v10.26H14.97V18.38h10.11Zm-1.862 6.075h-6.385v2.295h6.385v-2.295Zm0-4.185h-6.384l-.001 2.295h6.385V20.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSim);
export default __webpack_public_path__ + "static/media/SIM.be311820a63cc1b04a94099df855faf5.svg";
export { ForwardRef as ReactComponent };